import { render } from "./CorporateContact.vue?vue&type=template&id=381db41e&scoped=true"
const script = {}

import "./CorporateContact.vue?vue&type=style&index=0&id=381db41e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381db41e"]])

export default __exports__